import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthErrorInterceptorService } from './auth-error-interceptor.service';
import { AuthHeaderInterceptorService } from './auth-header-interceptor.service';

export const httpInterceptProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthHeaderInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthErrorInterceptorService,
    multi: true,
  },
];
